import { useEffect, useRef, useState } from "react";

const useVideoDuration = (src) => {
  const videoRef = useRef(document.createElement("video"));
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (!src) {
      setDuration(0); // reset if src becomes invalid
      return;
    }
    const video = videoRef.current;
    video.preload = "metadata";
    video.src = src;

    const handleLoadedMetadata = () => {
      setDuration(video.duration);
    };

    video.addEventListener("loadedmetadata", handleLoadedMetadata);

    return () => {
      video.removeEventListener("loadedmetadata", handleLoadedMetadata);
      video.src = ""; // clean up
    };
  }, [src]);

  return duration;
};

export default useVideoDuration;
